import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { CustomValidators } from 'ng2-validation';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';;
import { UserService } from 'src/app/services/user.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { CareerService } from 'src/app/services/career.service';
import { OpponentsService } from 'src/app/services/opponents.service';
import { TournamentsService } from 'src/app/services/tournamnet.service';
import * as moment from 'moment';


@Component({
  selector: 'app-my-achivements',
  templateUrl: './my-achivements.component.html',
  styleUrls: ['./my-achivements.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class MyAchivementsComponent implements OnInit {

  countdown: number = 10;
  countdownInProgress: boolean = false;
  public item;
  public profileDetails;
  public loggedInUser;
  public userId;
  public isLoggedIn: boolean = false;
  WithdrawcnfModal: boolean = false; 
  thankwithdraw: boolean = false; 
  thankwithdrawinfo:boolean=false;
  wid:any;
  tname:any;
  mtn:any;
  agn:any;
  public data: any;
  public careerDetails;
  public highestSkillJumpDetails;
  public options = {
    title: {
      display: true,
      text: 'My Title',
      fontSize: 16
    },
    legend: {
      position: 'bottom'
    }
  }
  matchTypes = environment.matchTypes;
  public opponentList: any = [];
  public tournamentList: any = [];
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  rankData: any;
  skillsData: any;
  basicOptions: any;
  public paginationOption = environment.pagination;
  public matchList: any = [];
  private lazyLoadEvent: LazyLoadEvent;
  public downloadFlg: boolean = false;
  public loading: boolean = false;
  public totalRecords: Number = 0;
  public startDate: Date;
  public endDate: Date;
  public errorMessage;
  public searchby;
  constructor(

    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private tokenStorage: TokenStorageService,
    private router: Router,
    private userService: UserService,
    private careerService: CareerService,
    private opponentsService: OpponentsService,
    private tournamentsService: TournamentsService,
  ) {

  }
  ngOnInit(): void {
    this.basicOptions = {
      plugins: {
        legend: {
          labels: {
            color: '#495057'
          }
        }
      },
      scales: {
        x: {
          ticks: {
            color: '#495057'
          },
          grid: {
            color: '#ebedef'
          }
        },
        y: {
          ticks: {
            color: '#495057'
          },
          grid: {
            color: '#ebedef'
          }
        }
      }
    };
    this.rankData = {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
        {
          label: 'Rank',
          data: [0, 10, 5, 2, 20, 1, 12, 25, 20, 10, 8],
          fill: false,
          borderColor: '#42A5F5',
          tension: .4
        },
      ]
    };
    this.skillsData = {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
        {
          label: 'Skills',
          data: [10, 1, 15, 23, 2, 12, 15, 5, 1, 10, 8],
          fill: false,
          borderColor: '#7CFC00',
          tension: .4
        },
      ]
    };




    this.data = {
      // labels: ['Skill', 'Skill', 'Skill'],
      type: 'doughnut',
      weight:5,
        // labels: ['Skill', 'Skill', 'Skill'],
        datasets: [
          {
            label: 'skill',
            data: [800, 210, 150, 225, 435, 100],
            borderRadius: 5,
            cutout: 60,
            cutoutPercentage: 40,        
            backgroundColor: [
                'rgb(235, 124, 166)',
                'rgb(255, 172, 200)',
                'rgb(204, 111, 248)',
                'rgb(124, 92, 252)',
                'rgb(92, 175, 252)',
                'rgb(161, 169, 254)'
            ],
            hoverOffset: 10,
            spacing: 8,
            
          }]
          
    };

    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.isLoggedIn = true;
      this.userId = this.loggedInUser.userdata.id;
    }
    if (this.isLoggedIn == false) {
      this.router.navigate(['/']);
    }
    
    //this.getMyTournamentList(this.lazyLoadEvent);
  }
  onclickTournamentdetails(id) {
    this.router.navigate(["tournaments/factsheet/" + id]);
  }

  getMyTournamentList(event: LazyLoadEvent) {
    //console.log(event);
    this.lazyLoadEvent = event;
    var query = "?filterByDisabled=false&filterByUserId=" + this.userId;
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = (event.first / event.rows) + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }

    if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
      //console.log(params);
    }

    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    /**
    * Sequence wise sort.
    **/
    // else {
    //     query += "&sortBy=getSequencewise" + "&orderBy=desc";
    // }
    this.tournamentsService.getPlayerAcheivement(query).subscribe(
      data => {
        window.scroll(0, 0);
        this.loading = false;
        this.matchList = [];
        this.matchList = data.data.items;    
        this.totalRecords = data.data.totalCount;
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  getUserDetails(userId) {
    this.userService.getUserDetails(userId).subscribe(
      data => {
        this.item = data;
        if (this.item) {
          this.profileDetails = this.item;
        }

      }, err => {

      });

  }

  getCareerDetails() {
    this.careerService.getCareerDetails().then(
      data => {

        this.careerDetails = data[0];

      }, err => {

      });
  }

  getOpponentsList() {
    this.opponentsService.getOpponentsList().then(
      data => {
        this.opponentList = data;


      }, err => {

      }
    )
  }
  startCountdown(): void {
    this.countdownInProgress = true;
    const interval = setInterval(() => {
      this.countdown--;
      if (this.countdown === 0) {
        clearInterval(interval);
        this.countdownInProgress = false;
      }
    }, 1000);
  }

  resetCountdown(): void {
    this.countdown = 10;
    this.countdownInProgress = false;
  }
  getHighestSkillJumpData() {
    this.careerService.getHighestSkillJumpDetails().then(
      data => {

        this.highestSkillJumpDetails = data;

      }, err => {

      });
  }

  getTournamentsList() {
    this.tournamentsService.getTournamentsList().then(
      data => {
        //console.log('tournamentList', data);
        this.tournamentList = data;

      }, err => {

      });
  }

  withdrawModal(wid,tname,mtn,agn){
    this.WithdrawcnfModal = true;
    this.wid=wid;
    this.tname=tname;
    this.mtn=mtn;
    this.agn=agn;
  }
  thankyouwithdraw(){
    
    this.WithdrawcnfModal = false;
    const wbody = {
      disable: true,
      playerId: this.userId
    };
    this.tournamentsService.getwithdrawamount(this.wid, wbody).subscribe(
      (res) => {
        this.wid="";
        this.tname="";
        this.mtn="";
        this.agn="";
        //console.log("Updated Tournament Player:", res);
        this.thankwithdrawinfo= true;
        this.countdownInProgress = true;
        const interval = setInterval(() => {
          this.countdown--;
          if (this.countdown === 0) {
            clearInterval(interval);
            this.countdownInProgress = false;
            window.location.reload();
          }
        }, 1000);
        // this.thankwithdraw = true;
        // setTimeout(() => {
        //   window.location.reload();
        // }, 6000);
      },
      (error) => {
        // Handle error (e.g., show an error message)
        console.error('Error updating tournament player:', error);
      }
    );
  }
  downloadPdf(certificatePic) {
    window.open(certificatePic);
}
}
